/* tslint:disable */
/* eslint-disable */
/**
 * MINDD Survey API Server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AnswerSheetCreateRequest } from '../model';
// @ts-ignore
import type { CancellationRequest } from '../model';
// @ts-ignore
import type { SleepDiary } from '../model';
// @ts-ignore
import type { SleepSession } from '../model';
// @ts-ignore
import type { SleepSessionCreateRequest } from '../model';
// @ts-ignore
import type { SleepSessionSummaryRow } from '../model';
/**
 * SleepSessionControllerApi - axios parameter creator
 * @export
 */
export const SleepSessionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AnswerSheetCreateRequest} answerSheetCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        answer1: async (answerSheetCreateRequest: AnswerSheetCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'answerSheetCreateRequest' is not null or undefined
            assertParamExists('answer1', 'answerSheetCreateRequest', answerSheetCreateRequest)
            const localVarPath = `/api/v1/sleep-sessions/answer-sheets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(answerSheetCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {CancellationRequest} cancellationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSleepSession: async (sessionId: string, cancellationRequest: CancellationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('cancelSleepSession', 'sessionId', sessionId)
            // verify required parameter 'cancellationRequest' is not null or undefined
            assertParamExists('cancelSleepSession', 'cancellationRequest', cancellationRequest)
            const localVarPath = `/api/v1/sleep-sessions/{sessionId}/cancel`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancellationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SleepSessionCreateRequest} sleepSessionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSleepSession: async (sleepSessionCreateRequest: SleepSessionCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sleepSessionCreateRequest' is not null or undefined
            assertParamExists('createSleepSession', 'sleepSessionCreateRequest', sleepSessionCreateRequest)
            const localVarPath = `/api/v1/sleep-sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sleepSessionCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSleepDiaries: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('getSleepDiaries', 'sessionId', sessionId)
            const localVarPath = `/api/v1/sleep-sessions/{sessionId}/sleep-diary`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSleepDiary: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/sleep-sessions/sleep-diary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSleepSessions: async (patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getSleepSessions', 'patientId', patientId)
            const localVarPath = `/api/v1/sleep-sessions/patient/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 발송예정·진행중은 전부, 완료·취소는 최근 7일 이내만 반환한다. 환자 이름/성별/차트번호는 응답에 없으며 웹이 환자목록과 patientId 로 조합한다.
         * @summary 병원 수면일기 현황 목록
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummary: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/sleep-sessions/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SleepSessionControllerApi - functional programming interface
 * @export
 */
export const SleepSessionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SleepSessionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AnswerSheetCreateRequest} answerSheetCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async answer1(answerSheetCreateRequest: AnswerSheetCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.answer1(answerSheetCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SleepSessionControllerApi.answer1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {CancellationRequest} cancellationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelSleepSession(sessionId: string, cancellationRequest: CancellationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelSleepSession(sessionId, cancellationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SleepSessionControllerApi.cancelSleepSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SleepSessionCreateRequest} sleepSessionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSleepSession(sleepSessionCreateRequest: SleepSessionCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SleepSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSleepSession(sleepSessionCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SleepSessionControllerApi.createSleepSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSleepDiaries(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SleepDiary>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSleepDiaries(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SleepSessionControllerApi.getSleepDiaries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSleepDiary(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SleepDiary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSleepDiary(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SleepSessionControllerApi.getSleepDiary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSleepSessions(patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SleepSession>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSleepSessions(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SleepSessionControllerApi.getSleepSessions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 발송예정·진행중은 전부, 완료·취소는 최근 7일 이내만 반환한다. 환자 이름/성별/차트번호는 응답에 없으며 웹이 환자목록과 patientId 로 조합한다.
         * @summary 병원 수면일기 현황 목록
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSummary(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SleepSessionSummaryRow>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSummary(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SleepSessionControllerApi.getSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SleepSessionControllerApi - factory interface
 * @export
 */
export const SleepSessionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SleepSessionControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {AnswerSheetCreateRequest} answerSheetCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        answer1(answerSheetCreateRequest: AnswerSheetCreateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.answer1(answerSheetCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {CancellationRequest} cancellationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSleepSession(sessionId: string, cancellationRequest: CancellationRequest, options?: any): AxiosPromise<void> {
            return localVarFp.cancelSleepSession(sessionId, cancellationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SleepSessionCreateRequest} sleepSessionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSleepSession(sleepSessionCreateRequest: SleepSessionCreateRequest, options?: any): AxiosPromise<SleepSession> {
            return localVarFp.createSleepSession(sleepSessionCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSleepDiaries(sessionId: string, options?: any): AxiosPromise<Array<SleepDiary>> {
            return localVarFp.getSleepDiaries(sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSleepDiary(options?: any): AxiosPromise<SleepDiary> {
            return localVarFp.getSleepDiary(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSleepSessions(patientId: string, options?: any): AxiosPromise<Array<SleepSession>> {
            return localVarFp.getSleepSessions(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 발송예정·진행중은 전부, 완료·취소는 최근 7일 이내만 반환한다. 환자 이름/성별/차트번호는 응답에 없으며 웹이 환자목록과 patientId 로 조합한다.
         * @summary 병원 수면일기 현황 목록
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummary(options?: any): AxiosPromise<Array<SleepSessionSummaryRow>> {
            return localVarFp.getSummary(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SleepSessionControllerApi - object-oriented interface
 * @export
 * @class SleepSessionControllerApi
 * @extends {BaseAPI}
 */
export class SleepSessionControllerApi extends BaseAPI {
    /**
     * 
     * @param {AnswerSheetCreateRequest} answerSheetCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SleepSessionControllerApi
     */
    public answer1(answerSheetCreateRequest: AnswerSheetCreateRequest, options?: RawAxiosRequestConfig) {
        return SleepSessionControllerApiFp(this.configuration).answer1(answerSheetCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sessionId 
     * @param {CancellationRequest} cancellationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SleepSessionControllerApi
     */
    public cancelSleepSession(sessionId: string, cancellationRequest: CancellationRequest, options?: RawAxiosRequestConfig) {
        return SleepSessionControllerApiFp(this.configuration).cancelSleepSession(sessionId, cancellationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SleepSessionCreateRequest} sleepSessionCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SleepSessionControllerApi
     */
    public createSleepSession(sleepSessionCreateRequest: SleepSessionCreateRequest, options?: RawAxiosRequestConfig) {
        return SleepSessionControllerApiFp(this.configuration).createSleepSession(sleepSessionCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SleepSessionControllerApi
     */
    public getSleepDiaries(sessionId: string, options?: RawAxiosRequestConfig) {
        return SleepSessionControllerApiFp(this.configuration).getSleepDiaries(sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SleepSessionControllerApi
     */
    public getSleepDiary(options?: RawAxiosRequestConfig) {
        return SleepSessionControllerApiFp(this.configuration).getSleepDiary(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SleepSessionControllerApi
     */
    public getSleepSessions(patientId: string, options?: RawAxiosRequestConfig) {
        return SleepSessionControllerApiFp(this.configuration).getSleepSessions(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 발송예정·진행중은 전부, 완료·취소는 최근 7일 이내만 반환한다. 환자 이름/성별/차트번호는 응답에 없으며 웹이 환자목록과 patientId 로 조합한다.
     * @summary 병원 수면일기 현황 목록
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SleepSessionControllerApi
     */
    public getSummary(options?: RawAxiosRequestConfig) {
        return SleepSessionControllerApiFp(this.configuration).getSummary(options).then((request) => request(this.axios, this.basePath));
    }
}

